import type { PostLoginTranslations } from './types';

export const missionsTranslations = {
  'missions.dailyQuest.title': { es: 'Daily Quest', en: 'Daily Quest' },
  'missions.dailyQuest.description': {
    es: 'Tu ritual diario: enfócate en la misión clave del día y mantené la racha.',
    en: "Your daily ritual: focus on today's key quest and keep your streak alive.",
  },
} satisfies PostLoginTranslations;
